import { db } from "@/firebase";
import { useToast, useUserStore } from "@/store";
import { type Account } from "@aircap/common/account";
import { supervisorRoles } from "@aircap/common/auth";
import { captureException } from "@sentry/vue";
import { collection, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { useRouter } from "vue-router";

const treezorUserHome = async () => {
  const user = useUserStore();
  if (!user.uid) throw new Error("User ID is required");
  const snapshot = await getDocs(
    query(
      collection<Account>(db, "accounts"),
      where<Account>("userIds", "array-contains", user.uid),
      orderBy<Account>("createdAt", "desc"),
      limit(1),
    ),
  );
  const latest = snapshot.docs[0];
  if (!latest) return { name: "OpenAccount" };
  return { name: "Account", params: { accountId: latest.id } };
};

export const useRedirect = () => {
  const user = useUserStore();
  const router = useRouter();
  const { showErrorToast } = useToast();

  const redirectToHome = async () => {
    try {
      if (user.isKind("admin")) {
        user.setAdminSupervisorOrgId(null);
        await router.push({ name: "AdminSupervisorOrgs" });
        return;
      }
      if (user.hasRole(supervisorRoles, "supervisorOrg")) {
        await router.push({ name: "SupervisorOrgDashboard" });
        return;
      }
      if (user.isKind("user")) {
        const home = await treezorUserHome();
        await router.push(home);
        return;
      }
      await router.push({ name: "Accounts" });
    } catch (cause) {
      const error = new Error("Error redirecting to home", { cause });
      console.error(error);
      captureException(error);
      showErrorToast();
    }
  };

  return { redirectToHome };
};
